"use client";

import { Button, type ButtonProps } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconPlus } from "@tabler/icons-react";
import { useTranslations } from "next-intl";
import type { PaywallTrigger } from "@/lib/analytics/events";
import { TopUpCreditsModal } from "./TopUpCredits";

interface TopUpCreditsButtonProps extends ButtonProps {
  /** Reported on the modal's `paywall_viewed` / `checkout_started`. */
  trigger: PaywallTrigger;
}

export function TopUpCreditsButton({
  trigger,
  ...rest
}: TopUpCreditsButtonProps) {
  const [opened, { open, close }] = useDisclosure(false);
  const t = useTranslations("app.dashboard.account.TopUpCreditsButton");

  return (
    <>
      <Button
        onClick={open}
        color="green.9"
        leftSection={<IconPlus />}
        {...rest}
      >
        {t("label")}
      </Button>

      <TopUpCreditsModal opened={opened} onClose={close} trigger={trigger} />
    </>
  );
}
